exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".truncated-text .reveal-text[data-v-355e47fe] {\n  padding-left: 0.3em;\n}\n.truncated-text .reveal-text.as-block[data-v-355e47fe] {\n  padding-left: 0;\n  display: block;\n}\n", ""]);

// exports
